

























































import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { InstanceGroup } from "@/services/instances/types";
import { NewsInstanceGroup } from "@/services/news/types";
import { getAllInstanceGroups } from "@/services/instances/instanceGroupService";
import { selectInstanceGroupsFields } from "@/components/news/fields/selectInstanceGroupsFields";
import i18n from "@/i18n";
import { RoleEnum } from "@/store/authentication/types";
const namespace: string = "authentication";

    @Component
export default class SelectInstanceGroupsModal extends Vue {
        @Getter("authorize", { namespace }) authorize: any;
        roles = RoleEnum;
        instanceGroups = [] as InstanceGroup[];
        fields = selectInstanceGroupsFields;
        isBusy = false;
        sortBy = "name";
        sortDesc = false;
        selectedInstanceGroups = [] as InstanceGroup[];
        multiPicker = false;
        // filter options
        searchQuery = "";
        // lifecycle hooks

        // computed
        get filteredData() {
            return this.instanceGroups && this.instanceGroups
                .filter(x => this.searchQuery.length === 0 ||
                    (x.name.toLowerCase().includes(this.searchQuery.toLowerCase())));
        }

        get title(): string {
            return i18n.t("instanceGroups.selectInstnaceGroups").toString();
        }

        // methods
        fetchData() {
            this.isBusy = true;
            getAllInstanceGroups().then(response => {
                const allInstanceGroups = response;
                this.instanceGroups = allInstanceGroups.filter(x => x.restricted ? this.authorize(this.roles.RestrictedAccessRole) : true);
                this.isBusy = false;
            });
        }

        rowSelected(items: InstanceGroup[]) {
            this.selectedInstanceGroups = items;
        }

        open(multiPicker = false) {
            this.multiPicker = multiPicker;
            this.fetchData();
            this.$bvModal.show("modal-selectInstanceGroup");
        }

        save() {
            this.$bvModal.hide("modal-selectInstanceGroup");
            if (!this.instanceGroups || this.selectedInstanceGroups.length === 0) {
                return;
            }

            this.$emit("select", this.selectedInstanceGroups.map(group => {
                return {
                    instanceGroupId: group.id,
                    name: group.name
                } as NewsInstanceGroup;
            }));
        }

        resetState() {
            this.searchQuery = "";
            this.selectedInstanceGroups = [] as InstanceGroup[];
        }
}
